import React from "react";

import PinLocate from '../img/bullet_location_a.png';
import Profile from '../img/mas-sigit.gif';
import People1 from '../img/people1.jpg';
import People2 from '../img/people2.jpg';
import People3 from '../img/people3.jpg';
import People4 from '../img/people4.jpg';
import People5 from '../img/people5.jpg';
import People6 from '../img/people6.jpg';

class People extends React.Component {
  render() {
    return (
      <div class="container d-flex h-100">
        <div class="align-self-center w-100 row">
          <div class = 'col-lg-12 col-md-12 offset-lg-3'>
            <h1 class = 'jobs-moving-title jobs-heading-title'>(Some Of) Our Team</h1>
          </div>
          <div class ="col-lg-3 col-6 offset-lg-3" style = {{textAlign: 'right'}}>
            <div class = 'people-content-container'>
              <div>
                <img class = 'people-spotlight' src = {Profile} width = '100%'/>
              </div>
            </div>
          </div>
          <div class ="col-lg-6 col-6">
            <div class = 'jobs-content-container h-100'>
              <p class = 'people-paragraph h-100'>
                <div class = 'd-flex h-100'>
                  <div class = 'align-self-center'>
                    <h4 class = 'community-title-modifier people-quote article-title'>"Teknologi selalu berkembang, makanya kita harus selalu belajar."</h4>
                    <span class = 'people-name'>Sigit Nurseto</span><br/>
                    <span class = 'people-title'>Engineering Manager</span>
                    <div style = {{height:'5px', width: '50px', marginTop: '20px', backgroundColor:'#e0df87'}} />
                  </div>
                </div>
              </p>
            </div>
          </div>
          <div class = 'col-lg-9 col-md-12 offset-lg-3 row' style = {{marginTop:'16px'}}>
            <div class = 'col-sm-2 col-4'>
              <img src = {People1} width = '100%'/>
              <p style = {{lineHeight:'0.8', marginTop:'5px'}}>
              <span class = 'people-name-thumb'>Omar Abdillah</span><br/>
              <span class = 'people-title-thumb'>Data & Analytics Lead</span></p>
            </div>
            <div class = 'col-sm-2 col-4'>
              <img src = {People2} width = '100%'/>
              <p style = {{lineHeight:'0.8', marginTop:'5px'}}>
              <span class = 'people-name-thumb'>Sigit Nurseto</span><br/>
              <span class = 'people-title-thumb'>Engineering Manager</span></p>
            </div>
            <div class = 'col-sm-2 col-4'>
              <img src = {People3} width = '100%'/>
              <p style = {{lineHeight:'0.8', marginTop:'5px'}}>
              <span class = 'people-name-thumb'>Taufik Hidayat</span><br/>
              <span class = 'people-title-thumb'>Software Engineer</span></p>
            </div>
            <div class = 'col-sm-2 col-3 d-none d-sm-block'>
              <img src = {People4} width = '100%'/>
              <p style = {{lineHeight:'0.8', marginTop:'5px'}}>
              <span class = 'people-name-thumb'>Thomas Dwi P.</span><br/>
              <span class = 'people-title-thumb'>Product Designer</span></p>
            </div>
            <div class = 'col-sm-2 col-3 d-none d-sm-block'>
              <img src = {People5} width = '100%'/>
              <p style = {{lineHeight:'0.8', marginTop:'5px'}}>
              <span class = 'people-name-thumb'>Angga Dwi A.</span><br/>
              <span class = 'people-title-thumb'>Mobile Engineer</span></p>
            </div>
            <div class = 'col-sm-2 col-3 d-none d-sm-block'>
              <img src = {People6} width = '100%'/>
              <p style = {{lineHeight:'0.8', marginTop:'5px'}}>
              <span class = 'people-name-thumb'>Angga Kesuma</span><br/>
              <span class = 'people-title-thumb'>Senior Software Engineer</span></p>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default People;



// WEBPACK FOOTER //
// ./src/components/People.js